import React, { Component } from 'react';
import { InputGroup, Input } from 'reactstrap';
import * as Yup from 'yup';

class RevueForm extends Component {
  render() {
    return (
      <div id="revue-embed" style={{width:370}}>
        <form action="https://www.getrevue.co/profile/growjo/add_subscriber" method="post" id="revue-form" name="revue-form"  target="_blank">
          {/* <input className="revue-form-field" placeholder="Your email address..." type="email" name="member[email]" id="member_email" /> */}
          <InputGroup style={{marginBottom:10}}>
            <Input type="email"
                    name="member[email]"
                    id="member_email"
                    placeholder="Your email address..."
                    required
            />
            <div className="input-group-append">
              <span className="input-group-text"><i className="fa fa-envelope"></i></span>
            </div>
            {/* <FormFeedback>{errors.EMAIL}</FormFeedback> */}
          </InputGroup>
          {/* <input className="revue-form-field" placeholder="First name... (Optional)" type="text" name="member[first_name]" id="member_first_name" /> */}
          <InputGroup style={{marginBottom:10}}>
            <Input type="text"
                    name="member[first_name]"
                    id="member_first_name"
                    placeholder="First name... (Optional)"
                    required = {false}
            />
          </InputGroup>
          {/* <input className="revue-form-field" placeholder="Last name... (Optional)" type="text" name="member[last_name]" id="member_last_name" /> */}
          <InputGroup style={{marginBottom:10}}>
            <Input type="text"
                    name="member[last_name]"
                    id="member_last_name"
                    placeholder="Last name... (Optional)"
                    required = {false}
            />
          </InputGroup>
          <div className="revue-form-actions">
            <input type="submit" value="Subscribe" name="member[subscribe]" id="member_submit" className="btn btn-success" style={{float:"right"}}/>
          </div>
        </form>
      </div>
      );
  }
}

export default RevueForm;



// WEBPACK FOOTER //
// ./client/src/components/revueForm.js